import Blacklist from './Blacklist';

export default Blacklist;
